import { render, staticRenderFns } from "./smsCodeLogin.vue?vue&type=template&id=1197c528&scoped=true&"
import script from "./smsCodeLogin.vue?vue&type=script&lang=js&"
export * from "./smsCodeLogin.vue?vue&type=script&lang=js&"
import style0 from "./smsCodeLogin.vue?vue&type=style&index=0&id=1197c528&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1197c528",
  null
  
)

export default component.exports